import React, {Component} from 'react';
import '../css/Sub.css';
import WOW from "wow.js";
import '../css/Animated.css'
import Slider from "react-slick";
import "../css/slick.css";
import "../css/slick-theme.css";

class Sub extends Component{
  constructor(props){
    super(props)
    this.state={
    }
  }
  
  componentDidMount(){
    var wow = new WOW(
      {
        boxClass:     'wow',      // animated element css class (default is wow)
        animateClass: 'animated', // animation css class (default is animated)
        offset:       0,          // distance to the element when triggering the animation (default is 0)
        mobile:       true,       // trigger animations on mobile devices (default is true)
        live:         true,       // act on asynchronously loaded content (default is true)
        callback:     function(box) {
          // the callback is fired every time an animation is started
          // the argument that is passed in is the DOM node being animated
        },
        scrollContainer: null,    // optional scroll container selector, otherwise use window,
        resetAnimation: true,     // reset animation on end (default is true)
      }
    );
    wow.init();
  }

  render(){
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth : true
    };
    return(
      <div className='sub'>
        <div className='wow fadeInUp chap01' data-wow-iteration='1'>
            <div className='img01'><img src='img/chap01.png' alt='cahp01'/></div>
            <div className='text01'>
              <div>공동육아</div>
              <div>모든 걸 공유하는</div>
              <div>우리는 가족이니까!</div>
              <div>오늘 우리 아이 산책은 누가 시켰을까?</div>
              <div>온 가족이 함께 쓰고 관리하는 반려견 육아 일기</div>
            </div>
        </div>
        <div className='wow fadeInUp chap02'>
            <div className='text02'>
              <div>질문</div>
              <div>매일 만나보는 새로운 질문들로</div>
              <div>반려견에 대한 애정과 관심 UP!</div>
              <div>반려견에 대한 애정과 관심이 필요한 질문들이 매일 등장해요!</div>
              <div>질문에 답변하고, 가족들의 답변도 읽어보세요!</div>
            </div>
            <div className='img02'><img src='img/chap02.png' alt='cahp02'/></div>
        </div>
        <div className='wow fadeInUp chap03'>
            <div className='img03'>
              <div className='imgW03'>
                <Slider {...settings}>
                  <div><img className='img3' src='img/chap03.png' alt='cahp03'/></div>
                  <div><img className='img3' src='img/chap03_2.jpg' alt='cahp03_2'/></div>
                </Slider>
              </div>
            </div>
            <div className='text03'>
              <div>기록</div>
              <div>아이의 하루에 대해 기록하고</div>
              <div>가족과 함께 공유해 보세요!</div>
              <div>오늘 밥과 간식, 영양제를 몇번이나 주었는지 기록해두면</div>
              <div>공동 육아 중인 가족들이 한 눈에 확인할 수 있어요!</div>
            </div>
        </div>
        <div className='wow fadeInUp chap04'>
            <div className='text04'>
              <div>포인트</div>
              <div>아이에 대해 기록할 때마다</div>
              <div>차곡차곡 쌓이는 포인트!</div>
              <div>매일매일 아이에 대해 기록하고 받아가는 포인트!</div>
              <div>모아둔 포인트로는 맞춤식단 구매가 가능해요!</div>
            </div>
            <div className='img04'><img src='img/chap04.png' alt='cahp04'/></div>
        </div>
        <div className='wow fadeInUp chap05'>
            <div className='img05'><img src='img/chap05.png' alt='cahp05'/></div>
            <div className='text05'>
              <div>기부</div>
              <div>맞춤식단 구매하고,</div>
              <div>선한 영향력을 실천해 보세요!</div>
              <div>도닥밀을 구매하시면 구매 금액의 3%가</div>
              <div>유기견 보호소로 기부가 됩니다!</div>
            </div>
        </div>
        <div className='wow fadeInUp chap06'>
        <div className='text06'>
              <div>리포트</div>
              <div>내가 작성한 아이 기록들을 분석해</div>
              <div>더욱 건강해지는 법을 알려줘요</div>
              <div>아이에게 적절한 몸무게, 부족한 영양소, 유전 질병 등</div>
              <div>기록된 정보를 바탕으로 아이 건강에 대해 분석한 결과를 볼 수 있어요!</div>
            </div>
            <div className='img06'>
              <div className='imgW06'>
                <Slider {...settings}>
                  <div><img className='img6' src='img/chap06.png' alt='cahp06'/></div>
                  <div><img className='img6' src='img/chap06_2.jpg' alt='cahp06_2'/></div>
                  <div><img className='img6' src='img/chap06_3.jpg' alt='cahp06_3'/></div>
                </Slider>
              </div>
            </div>
        </div>
        <div className='wow fadeInUp chap07'>
            <div className='img07'><img src='img/chap07.png' alt='cahp07'/></div>
            <div className='text07'>
              <div>맞춤식단</div>
              <div>전문 펫영양사가 직접 만드는</div>
              <div>우리 아이 1:1 맞춤식단</div>
              <div>알러지 유무, 건강 상태를 고려한 1:1맞춤식단!</div>
              <div>우리 아이가 화식을 잘 먹을지 고민이 된다면?</div>
              <div>본품과 동일한 구성의 기호성 테스트 먼저 받아보세요!</div>
            </div>
        </div>
      </div>
    )
  }
}

export default Sub;
